import client from '../client'

export async function reportImage({ vehicleId, photoType, photoId, reason }) {
  return client(`${process.env.NEXT_PUBLIC_LISTINGS_DOMAIN}/api/Vehicles/ReportImage`, {
    headers: { 'Content-Type': 'application/json ' },
    method: 'POST',
    body: JSON.stringify({ vehicleId, photoType, photoId, reason }),
  })
}
